// src/dataSource.js
//
// Single point of access for graph data. Today it reads the static
// rfc-graph.json produced by the data pipeline. To move to a real database
// later, only this file needs to change — components call loadGraph() and
// never touch fetch / SQL directly.

// Primary source: the live serverless function (self-updating, cached 24h).
// Fallback: the static snapshot in public/ — used during local `npm start`
// (no functions running) or if the function is temporarily unavailable.
const LIVE_URL = '/api/rfc-graph';
const STATIC_URL = `${process.env.PUBLIC_URL || ''}/rfc-graph.json`;

function normalize(data) {
    const nodes = data.nodes || [];
    const nodeIds = new Set(nodes.map(n => n?.data?.id).filter(Boolean));
    const edges = (data.edges || []).filter(
        e => nodeIds.has(e?.data?.source) && nodeIds.has(e?.data?.target)
    );
    return { nodes, edges };
}

async function fetchJson(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
}

/**
 * Load the full RFC graph. Tries the live function first, falls back to the
 * static snapshot. To move to a real database later, change only this file.
 * @returns {Promise<{ nodes: Array, edges: Array }>} cytoscape-ready elements.
 */
export async function loadGraph() {
    try {
        return normalize(await fetchJson(LIVE_URL));
    } catch (liveErr) {
        console.warn('Live data source failed, using static snapshot:', liveErr.message);
        return normalize(await fetchJson(STATIC_URL));
    }
}
